import React from 'react'
import { Box, styled, Typography } from "@mui/material";
import { Link } from 'react-router-dom'
import LOGOtransparent from '../../Assets/LOGOtransparent.webp';
import { BlackButton, OutlinedWhiteButton } from '../../Styles/Button';
export const Header = () => {

    const CustomBox = styled(Box) (({ theme }) => ({
        minHeight: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(2),
        background: '#FBFCFA',
        borderRadius: 10,
        marginBottom: theme.spacing(5),
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            textAlign: 'center',
        }
    }));

    const BoxText = styled(Box) (({ theme }) => ({
        flex: '1',
        paddingLeft: theme.spacing(8),
        [theme.breakpoints.down('md')]: {
            flex: '1',
            textAlign: 'center',
            paddingTop: theme.spacing(5),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    }));


  return (
    <>
        <CustomBox component='header'>
          <BoxText component='section'>
              <Typography variant='h2' component='h1'
                  sx={{
                      fontWeight: 700,
                      color: '#16191e',
                  }}
              >
                  Bienvenue au Chai !
              </Typography>
              <Typography variant='p' component='p'
                  sx={{
                      py: 2,
                      lineHeight: 1.6,
                      color: '#16191e',
                  }}
              >
                  Un nouveau lien, <br/>
                  accessible à chacun, <br/>
                  entre le rural et l’urbain ...
              </Typography>
              <Box
                  sx={{
                      display: 'flex',
                      gap: 5,
                      justifyContent: 'center',
                      alignItems: 'center',
                  }}>
                  <BlackButton
                    sx={{
                        py : 1.5,
                        width: '40%'
                    }}
                    component={Link}
                    to={'/ateliers'}
                  >
                      Nos ateliers
                  </BlackButton>
                  <OutlinedWhiteButton
                    sx={{
                        py : 1.5,
                        width: '40%'
                    }}
                    component={Link}
                    to={'/boutique'}
                  >
                      La boutique
                  </OutlinedWhiteButton>
              </Box>
          </BoxText>
          <Box sx={theme => ({
              [theme.breakpoints.down('md')]: {
                  flex: '1',
                  paddingTop: '30px',
                  alignSelf: 'center',
              },
              [theme.breakpoints.up('md')]: {
                  flex: '2',
                  alignSelf: 'flex-end',
              },
          })}
          >
            <img
                src={LOGOtransparent}
                alt="headerImg"
                style={{
                    width: "60%",
                    margin: 50
                }}
            />
          </Box>
        </CustomBox>
    </>
    )
}

export default Header